<template>
  <div class="content-item flex content-item-contentSkus">
    <div class="content-item-label">商品</div>

    <div class="contentSkus-tab-list flex">
      <div class="contentSkus-tab contentSkus-tab-add" @click="openDeseaseDialog">添加商品</div>
      <div class="contentSkus-tab contentSkus-tab-contentSku" v-for="(item,index) in contentSkus" :key="index">
        <el-tooltip class="item" effect="dark" :content="tooltipDetails(item)" placement="top-start">
          <span class="contentSkus-tab-text">{{item.skuId}}</span>
        </el-tooltip>
        <img src="~_img/off.png" alt="del" @click="delContentSkus(index)">
      </div>
    </div>
    <!-- <p>给文章打上相关的商品，可以帮您更好的展示文章</p> -->
    <modal
      :isShow.sync="dialogDeseaseVisible"
      :title="dialogTitles"
      :btnText="btnText"
      :isShowBtn="isShowBtn"
      :width="dialogWidth"
      @clickHandler="clickHandler"
    >
      <div class="search-dialog-wrap">
        <el-input placeholder="请输入商品ID" v-model="searchContentSkusName" class="input-with-select">
          <el-button slot="append" icon="el-icon-search" @click="queryContentSkus" class="search-but">搜索</el-button>
        </el-input>
        <div class="search-desease-body">
          <div class="search-data">
            <el-checkbox-group v-model="searchContentSkusChecked" v-if="searchContentSkusList.length&&!isShowSearchNoData" @change="searchContentSkusChange">
                <el-checkbox :label="item.skuId" v-for="(item,index) in searchContentSkusList" :key="index">
                  <el-tooltip class="item" effect="dark" :content="tooltipDetails(item)" placement="top-start">
                    <span class="checked_text">{{item.skuName+"("+item.skuId+")"}}</span>
                  </el-tooltip>
                </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="noData flex flex-direction-column justify-content-center align-items-center" v-if="isShowSearchNoData">
            <img src="~_img/search-noData.png" alt="没有数据">
            <p class="errorInfo">很抱歉，暂未收录相关商品</p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import { request } from '@/utils/axios';
	import modal from '@/components/modal'
	export default {
		name: "contentSkusLabel",
    props:['data', 'functionIds'],
    data(){
			return{
				deseaseTips: false,
				dialogDeseaseVisible: false, //添加商品弹窗
				isShowSearchNoData: false,
				searchContentSkusName: '',
				searchContentSkusList: [],
				searchContentSkusListHistory: [],
				searchContentSkusChecked: [],
				contentSkus:[],
				dialogTitles:'搜索商品',
				btnText:['取消','确认'],
				dialogWidth:'480px',
				isShowBtn:[true,true],
      }
    },
    components:{
	    modal
    },
    watch:{
      data(val) {
        console.log("🚀 ~ file: ContentSkusLabel.vue:74 ~ data ~ val:", val)

	      this.searchContentSkusChecked=[];

        if (val) {
          const filteredData = val.filter(item => item?.type != 2);
          for (let i = 0; i < filteredData.length; i++) {
            this.searchContentSkusChecked.push(filteredData[i].skuId);
          }
          this.contentSkus = filteredData;
          filteredData.forEach(item => {
            this.searchContentSkusListHistory.push(item);
          });
        }
      }
    },
    created(){
			// this.contentSkus=this.data;
    },
    methods:{
	    clickHandler(val){
        console.log("🚀 ~ file: ContentSkusLabel.vue:91 ~ clickHandler ~ val:", val, this.searchContentSkusList,this.searchContentSkusListHistory)
        if(val=='one'){
        	this.dialogDeseaseVisible=false
        }
        if(val=='two'){
          this.addContentSkus();
          // 过滤最新item
          // let skusList = [];
          // if (this.searchContentSkusList.length) {
          //   this.contentSkus?.forEach(skuItem => {
          //     this.searchContentSkusList.forEach(item => {
          //       if (item.skuId === skuItem.skuId) {
          //         skusList.push(item);
          //       }
          //     })
          //   })
          // } else {
          //   skusList = this.contentSkus;
          // }
          console.log("🚀 ~ file: ContentSkusLabel.vue:112 ~ clickHandler ~ skusList:", this.contentSkus);
          this.$emit('changeContentSkusLabels', this.contentSkus);
        }
      },
      //打开商品标签弹窗
      openDeseaseDialog() {
        this.dialogDeseaseVisible = true;
        this.isShowSearchNoData = false;
        this.searchContentSkusList = [];
        this.searchContentSkusName = '';
      },
      // 获取选中的商品标签
      searchContentSkusChange() {
        // if (this.searchContentSkusChecked && this.searchContentSkusChecked.length > 30) {
        //   this.$message.error('商品标签最多选30个~')
        //   this.searchContentSkusChecked.pop();
        // }
      },
      getsearchContentSkusListData() {
        let array = this.searchContentSkusListHistory.filter(item => {
          return this.searchContentSkusChecked.some(i => {
            return i == item.skuId
          })
        })
        let _map = []
        const filteredArray = array.filter((item) => {
          if (!_map.includes(item.skuId)) {
            _map.push(item.skuId)
            return true
          } else {
            return false
          }
        })

        // 给每一项添加 type: 1 （1:商品，2:搭配品）
        return filteredArray.map(item => ({
          ...item,
          type: 1
        }))
      },
      //添加商品
      addContentSkus() {
        // if (this.searchContentSkusChecked.length > 30) {
        //   return
        // }
        let dataList = this.getsearchContentSkusListData();
        // console.log("🚀 ~ file: ContentSkusLabel.vue:154 ~ addContentSkus ~ dataList:", dataList)
        this.contentSkus = this.contentSkus || [];
        this.contentSkus.splice(0, this.contentSkus.length, ...dataList)
        this.dialogDeseaseVisible = false
      },
      delContentSkus(index) {
        this.contentSkus.splice(index, 1);
        this.searchContentSkusChecked.splice(index, 1);
        this.$emit('changeContentSkusLabels', this.contentSkus);
      },
      // 搜索商品
      queryContentSkus() {
	    	if(this.searchContentSkusName){
          const skuList = this.searchContentSkusName.split(',');
			    request(this.functionIds.getContentSkus, {
            skuIds:skuList
          }).then(res => {
				    if (res && res.length) {
					    this.isShowSearchNoData = false
					    this.searchContentSkusList = res;
					    res.map(item => {
						    this.searchContentSkusListHistory.push(item)
					    })
				    } else {
					    this.isShowSearchNoData = true
				    }
			    }).catch(err=>{
				    this.isShowSearchNoData = true
			    })
        }else{
			    this.isShowSearchNoData = true
        }
      },
    },
    computed: {
      tooltipDetails: () => {
        return (item) => `${item.skuName}(${item.skuId})`;
      }
    }
	}
</script>

<style lang="scss" scoped>
@import "@/styles/dialog_common.scss";
$color:#266CEE;
.content-item-contentSkus {
  height: 52px;
  width: 100%;
}
.input-with-select{
  width: 437px !important;
  padding-bottom: 4px !important;
}
//商品搜索
.search-dialog-wrap{
  min-height: 138px;
  margin: 20px;
  .search-data{
    max-height: 138px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 20px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      height:30px;
      background-color: #989CA5;
    }
    .el-checkbox {
      margin-top: 8px;
      margin-right: 24px;
      display: flex;
    }
    ::v-deep .el-checkbox__label {
      color: #262626;
      padding-left: 6px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      white-space: normal;
      overflow: hidden;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background:$color;
      border-color:$color;
    }
    .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #262626;
    }
    .el-checkbox__inner:hover {
      border-color: $color;
    }
  }
  .noData{
    img{
      width:121px;
      height:78px;
      border: none;
    }
    p{
      font-size: 12px;
      color: #9a9a9a;
      margin-top: 20px;
    }
  }
}
.have{
    cursor:pointer
}
.btns{
  padding-bottom: 22px;
  padding-top: 40px;
  line-height: 0px !important;
}
.dialog-but{
  padding-top: 9px;
}
:deep(.button) {
  line-height: 0px !important;
}
:deep(.content-item) {
  min-width: 100% !important;
}
:deep(.el-button .el-button--primary) {
  padding-top: 10px;
}
  .search-but{
    padding-top: 8px;
  }
  .errorInfo{
    width: 145px !important;
    text-align: right;
    margin-right: 10px;
  }
  .desease-tips {
    width: 147px !important;
    height: 20px;
    position: absolute;
    left: 878px;
    top: 0;
  }
  .contentSkus-tab-add{
   width: 105px !important;
    position: absolute !important;
    left: 0px;
    top: -37px;
  }
.contentSkus-tab-list {
  width: 100%;
  flex-wrap: wrap;
  position: relative !important;
  .contentSkus-tab {
    display: inline-block;
    // width: max-content;
    height: 32px;
    line-height: 32px;
    text-align: center;
    // background: rgba(255, 110, 0, 0.12);
    border: 1px solid #0058ee;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    margin-top: 35px !important;
    cursor: pointer;
    // color: #FF6E00;
    color: #0058ee;
    position: relative;
    margin-bottom: 20px;
    .contentSkus-tab-text {
      width: 238px;
      min-width: 238px!important;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      white-space: normal;
      overflow: hidden;
    }
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
  }
  .contentSkus-tab-contentSku { 
    // margin-top: 50px!important;
    // margin-bottom: -25px;
  }
  .contentSkus-tab-add {
    border: 1px dashed rgba(154, 154, 154, 1);
    background: rgba(255, 255, 255, 1);
    color: rgba(38, 38, 38, 1);
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~_img/add.png") no-repeat;
      background-size: 12px;
    }
    &::after {
      display: none;
    }
  }
}
</style>
